export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-1.8d53ed19.png";